import React from 'react'
import type { AiChatReportSource } from '../../../shared/domain/aiChats/types.no-deps'
import { Tile } from '../../../shared/webcomponents/react-wrappers/Tile'
import type { Workflow } from '../../../shared/domain/workflows/types.no-deps'
import { getRelativeTimeMessage } from '../../../shared/lib/relativeTimeMessage.no-deps'
import type { Workflow as AppWorkflow } from '../workflow/Workflow'
import type { BaseSourceProps } from './ZapBot'

type Props = BaseSourceProps & {
    source: AiChatReportSource
    reportWorkflow?: Workflow | AppWorkflow
    onClick: () => void
}

export function ReportSource({ source, deps, reportWorkflow, number, onClick }: Props) {
    return (
        <Tile
            title={source.report.title ?? reportWorkflow?.name}
            number={number}
            onClick={() => onClick()}
            subtitle={getRelativeTimeMessage(deps.locale, source.report.submittedDate, new Date())}
        >
            <div className="ZapBot_report-source-icon" slot="icon">
                <zaptic-icon icon-name="report" />
            </div>

            <span className="ZapBot_source_warning-icon" slot="right-content">
                <zaptic-icon icon-name="warning-triangle"></zaptic-icon>
            </span>
        </Tile>
    )
}
